import { combineReducers } from 'redux';

import counter from './counter';
import container from './containerContext';
import openClaim from './openClaim';
import coverage from './coverage';
import claims from './claims';
import management from './management';
import stores from './stores';
import roles from './roles';
import storesContext from './storesContext';
import certificates from './certificates';
import reports from './reports';
import portal from './portal';

export default combineReducers({
  counter,
  container,
  coverage,
  openClaim,
  claims,
  management,
  stores,
  roles,
  storesContext,
  certificates,
  reports,
  portal,
});
